import RestrictedPositions from "./restricted-positions";
import { fillArray } from "../../../../services/common/object-util";

export default class PenaltyAcceptedFieldPositionRestrictedPositions extends RestrictedPositions {
    constructor(props) {
        super(props);
    }

    resolve() {
        const { fieldLength, endZoneLength } = this.gameConfig.general;

        return [
            ...fillArray(endZoneLength + 1, -endZoneLength),
            ...fillArray(endZoneLength + 1, fieldLength)
        ];
    }
}
